import React from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface LoginProps {
    onSubmit: (username: string, password: string) => void;
}

const Login = ({ onSubmit }: LoginProps) => {
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');

    function handleSubmit() {
        if (username && password) {
            onSubmit(username, password);
        }
    }

    async function onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            await handleSubmit();
        }
    }

    function onUserNameChange(e: React.ChangeEvent<HTMLInputElement>) {
        setUsername(e.target.value);
    }

    function onPasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
        setPassword(e.target.value);
    }

    return (
        <Container maxWidth="xs">
            <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign In
                </Typography>
                <Box component="form" sx={{ width: '100%', mt: 1 }}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Login name"
                        autoComplete="username"
                        value={username}
                        onKeyDown={onKeyDown}
                        onChange={onUserNameChange}
                        // eslint-disable-next-line jsx-a11y/no-autofocus -- intentional: focus the username field on login
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Password"
                        type="password"
                        value={password}
                        onKeyDown={onKeyDown}
                        onChange={onPasswordChange}
                        autoComplete="current-password"
                    />
                    <Button fullWidth variant="contained" color="primary" sx={{ mt: 3, mb: 2 }} onClick={handleSubmit}>
                        Sign In
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default React.memo(Login);
